import * as React from 'react';
import {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {
    Dashboard,
    ExpandLess,
    ExpandMore,
    RateReviewOutlined,
    SettingsOutlined,
    TripOriginOutlined
} from "@mui/icons-material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {Collapse} from "@mui/material";
import {BASE_URL} from "../constants";
import {reportErrors} from "../helpers";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import MailIcon from "@mui/icons-material/Mail";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MoreIcon from "@mui/icons-material/MoreVert";
import Trip from "./trip/Trip";
import ReviewTabs from "./review/ReviewTabs";
import Employee from "./cors/Employee";
import SettingsAndConfigurationTabs from "./settings/SettingsAndConfigurationTabs";
import DashboardPage from "./DashboardPage";
import ResponseTabs from "./response/ResponseTabs";
import Divider from "@mui/material/Divider";
import BarcodeConfigurationTab from "./cors/BarcodeConfigurationTab";

const drawerWidth = 240;

const selectedStyle = {
    minHeight: 48,
    justifyContent: 'initial',
    px: 2.5,
}

export default function Private() {
    const path = "/private";
    const location = useLocation();
    const navigate = useNavigate();
    const [user, setUser] = useState();
    const [selected, setSelected] = useState();
    const [selectedSubmenu, setSelectedSubmenu] = useState();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

    useEffect(() => {
        loadUser();
        loadSystemConfiguration();
    }, []);
    const loadUser = () => {
        window.axios
            .get(`${BASE_URL}api/authenticated-user`)
            .then((response) => {
                if (!response.data) {
                    navigate("/");
                }
                window.$user = response.data;
                setUser(window.$user);
            })
            .catch((error) => {
                navigate("/");
            });
    };

    const loadSystemConfiguration = () => {
        let url = `${BASE_URL}api/settings/system-configuration`;
        window.axios
            .get(url)
            .then((response) => {
                window.$config = {...response.data.data};
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };
    const handleMenuSelection = (item) => {
        setSelected(item.id === selected ? null : item.id);
        if (item.items.length > 0) {
        } else {
            navigate(path + "/" + item.route);
            setSelectedSubmenu(null);
        }
    }

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
        navigate("/");
    };

    const _getActiveLocation = (item) => {
        if (location.pathname.indexOf(item.route) !== -1) {
            return true;
        }
        return false;
    }
    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const menus = [
        {
            id: 1,
            icon: <Dashboard/>,
            label: "Dashboard",
            route: "dashboard",
            items: []
        },
        ...((user && user?.company?.businessType === "Tour Operator") ? [
            {
                id: 2,
                icon: <TripOriginOutlined/>,
                label: "Trips",
                route: "trip",
                items: []
            }
        ] : []),
        {
            id: 3,
            icon: <RateReviewOutlined/>,
            label: "Responses",
            route: "response",
            items: []
        },
        {
            id: 4,
            icon: <SettingsOutlined/>,
            label: "Settings",
            route: "settings",
            items: [
                {
                    id: 4.1,
                    icon: <KeyboardArrowRightIcon/>,
                    label: "Barcode Configuration",
                    route: "settings/barcode-configuration",
                },
                {
                    id: 4.2,
                    icon: <KeyboardArrowRightIcon/>,
                    label: "Questions & Answers",
                    route: "settings/question-answers",
                },
                {
                    id: 4.3,
                    icon: <KeyboardArrowRightIcon/>,
                    label: "User Management",
                    route: "settings/user-management",
                },
                {
                    id: 4.4,
                    icon: <KeyboardArrowRightIcon/>,
                    label: "System Configuration",
                    route: "settings/system-configuration",
                },
            ]
        }
    ];

    const menuId = "primary-search-account-menu";
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose}>Log Out</MenuItem>
        </Menu>
    );

    const mobileMenuId = "primary-search-account-menu-mobile";
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            <MenuItem>
                <IconButton size="large" aria-label="show 4 new mails" color="inherit">
                    <Badge badgeContent={4} color="error">
                        <MailIcon/>
                    </Badge>
                </IconButton>
                <p>Messages</p>
            </MenuItem>
            <MenuItem>
                <IconButton
                    size="large"
                    aria-label="show 17 new notifications"
                    color="inherit"
                >
                    <Badge badgeContent={17} color="error">
                        <NotificationsIcon/>
                    </Badge>
                </IconButton>
                <p>Notifications</p>
            </MenuItem>
            <MenuItem onClick={handleProfileMenuOpen}>
                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                >
                    <AccountCircle/>
                </IconButton>
                <p>Profile</p>
            </MenuItem>
        </Menu>
    );

    return (
        <Box sx={{display: 'flex'}}>
            <CssBaseline/>
            <Box sx={{flexGrow: 1}}>
                <AppBar position="fixed" sx={{zIndex: (theme) => theme.zIndex.drawer + 1}}>
                    <Toolbar>
                        <Typography variant="h6" noWrap component="div">
                            {user?.company?.name}
                        </Typography>
                        <Box sx={{flexGrow: 1}}/>
                        <Typography variant="h7" noWrap component="div">
                            {window.$user?.user?.fullName}
                        </Typography>
                        <Box sx={{display: {xs: "none", md: "flex"}}}>
                            <IconButton
                                size="large"
                                edge="end"
                                aria-label="account of current user"
                                aria-controls={menuId}
                                aria-haspopup="true"
                                onClick={handleProfileMenuOpen}
                                color="inherit"
                            >
                                <AccountCircle/>
                            </IconButton>
                        </Box>
                        <Box sx={{display: {xs: "flex", md: "none"}}}>
                            <IconButton
                                size="large"
                                aria-label="show more"
                                aria-controls={mobileMenuId}
                                aria-haspopup="true"
                                onClick={handleMobileMenuOpen}
                                color="inherit"
                            >
                                <MoreIcon/>
                            </IconButton>
                        </Box>
                    </Toolbar>
                </AppBar>
                {renderMobileMenu}
                {renderMenu}
            </Box>
            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: {width: drawerWidth, boxSizing: 'border-box'},
                }}
            >
                <Toolbar/>
                <Box sx={{overflow: 'auto'}}>
                    <List>
                        {menus.map((e, index) => (
                            <ListItem key={index} disablePadding sx={{display: 'block'}}>
                                <ListItemButton
                                    selected={(selected === e.id) || _getActiveLocation(e)}
                                    sx={(selected === e.id || _getActiveLocation(e)) ? selectedStyle : {
                                        minHeight: 48,
                                        justifyContent: 'initial',
                                        px: 2.5,
                                    }}
                                    onClick={() => handleMenuSelection(e)}
                                >
                                    <ListItemIcon>
                                        {e.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={e.label}/>
                                    {(e.items.length > 0) ? selected === e.id ? <ExpandLess/> :
                                        <ExpandMore/> : null}
                                </ListItemButton>
                                {e.items.map((sub, i) => (
                                    <Collapse
                                        in={(selected === e.id)}
                                        timeout="auto"
                                        unmountOnExit key={sub.id}
                                    >
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                selected={(selectedSubmenu === sub.id) || _getActiveLocation(sub)}
                                                sx={{pl: 4}}
                                                onClick={() => {
                                                    navigate(path + "/" + sub.route);
                                                    setSelectedSubmenu(sub.id);
                                                }}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    {sub.icon}
                                                </ListItemIcon>
                                                <ListItemText primary={sub.label}/>
                                            </ListItemButton>
                                        </List>
                                    </Collapse>
                                ))}
                                <Divider/>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>
            <Box sx={{flexGrow: 1, p: 3, width: '87vw'}}>
                <Toolbar/>
                <Routes>
                    <Route path={"/"} exact={true} element={<DashboardPage/>}/>
                    <Route path={"/dashboard"} exact={true} element={<DashboardPage/>}/>
                    <Route path={"/response"} element={<ResponseTabs/>}/>
                    <Route path={"/trip"} element={<Trip/>}/>
                    <Route path={"/settings/barcode-configuration"} element={<BarcodeConfigurationTab/>}/>
                    <Route path={"/settings/question-answers"} element={<ReviewTabs/>}/>
                    <Route path={"/settings/user-management"} element={<Employee/>}/>
                    <Route path={"/settings/system-configuration"} element={<SettingsAndConfigurationTabs/>}/>
                </Routes>
            </Box>
        </Box>
    );
}